<template>
  <div
    class="flex items-center justify-between border-transparent h-[49px] w-full pl-4 pr-2 py-3 text-gray-4 bg-gray-600 rounded-lg border-2 focus:outline-none text-gray-300"
  >
    <div class="truncated-url-data-attr" :data-short-url="truncateUrl(props.link)">
      <span class="full-url">
        {{ props.link }}
      </span>
    </div>

    <b-button
      size="sm"
      @click="copyToClipboard(props.link)"
      prepend-icon="solar:copy-linear"
    >
      <span v-if="!copied">{{ $t('copy_link.copy') }}</span>
      <span v-else>{{ $t('copy_link.copied') }}</span>
    </b-button>
  </div>
</template>

<script setup lang="ts">
import { truncateUrl } from "~/shared/utils/truncate";
import BButton from "~/components/forms/BButton.vue";
interface Props {
  link: string
}

const props = defineProps<Props>()
const copied = ref(false)

const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text).then(() => {
    copied.value = true
  }).catch((err) => {
    console.error('Failed to copy text: ', err);
  });
};
</script>

<style lang="scss">
.truncated-url-data-attr {
  position: relative;
}

.truncated-url-data-attr::after {
  content: attr(data-short-url);
  @apply text-gray-300;
}

.truncated-url-data-attr .full-url {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  color: transparent;
  user-select: all;
}
</style>
